import { render } from "./DocumentoImpressaoExtrato.vue?vue&type=template&id=68325cd2"
import script from "./DocumentoImpressaoExtrato.vue?vue&type=script&lang=js"
export * from "./DocumentoImpressaoExtrato.vue?vue&type=script&lang=js"

import "./DocumentoImpressaoExtrato.vue?vue&type=style&index=0&id=68325cd2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__